import { Record, Resource } from '@redge-media/fo-js-sdk';
import { assign } from '@atds-legacy/lang';

const Category = Record.extend({
  constructor: function Category(attrs = [], opts = {}) {
    Record.call(this, assign(attrs, {
      subcategories: new Subcategories({
        id: attrs.id,
      }),
    }), opts);
  },
});

const Subcategories = Resource.extend({});

export default Category;
